'use client';

import * as RadixForm from '@radix-ui/react-form';
import { BirthdateField } from '@tuic/web-compositions/core/BirthdateField';
import { InputFieldError, InputFieldLabel, InputFieldNote } from '@tuic/web-compositions/shared/InputField';
import type { AnyFieldApi } from '@tanstack/react-form';
import type { FC, ReactNode } from 'react';
export type ManifestBirthdateFieldProps = {
  field: AnyFieldApi;
  label?: ReactNode;
  note?: ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  locale?: string;
  minYear?: number;
  maxYear?: number;
};
export const ManifestBirthdateField: FC<ManifestBirthdateFieldProps> = ({
  field,
  label,
  note,
  required,
  disabled,
  className,
  locale,
  minYear,
  maxYear
}) => {
  const value = String(field.state.value ?? '');
  const error = field.state.meta.errors.map(e => e?.message).join(',');
  return <RadixForm.Field name={field.name} className={className} asChild data-sentry-element="RadixForm.Field" data-sentry-component="ManifestBirthdateField" data-sentry-source-file="ManifestBirthdateField.tsx">
      <div className="space-y-1">
        {label && <RadixForm.Label asChild>
            <InputFieldLabel asChild>
              <div>
                {label}
                {required ? '*' : ''}
              </div>
            </InputFieldLabel>
          </RadixForm.Label>}
        <BirthdateField name={field.name} value={value} locale={locale} disabled={disabled} minYear={minYear} maxYear={maxYear}
      // The library renders `<label>` above `<input>` in each per-part
      // wrapper; flip each wrapper to flex-col-reverse so the Tag/Monat/Jahr
      // labels sit beneath their inputs. gap-1 restores the small spacing.
      className="[&>div>div]:flex [&>div>div]:flex-col-reverse [&>div>div]:gap-1" onChange={v => field.handleChange(v)} data-sentry-element="BirthdateField" data-sentry-source-file="ManifestBirthdateField.tsx" />
        {error ? <InputFieldError>{error}</InputFieldError> : note && <InputFieldNote>{note}</InputFieldNote>}
      </div>
    </RadixForm.Field>;
};